import { useState, useRef } from "react";
import useVendorStore from "../../AuthStore/store/authStore";
import { useLocation, useNavigate } from "react-router-dom";

const OtpVerifyForm = () => {

   const { search } = useLocation();
  const query = new URLSearchParams(search);
  const id = query.get("id");


    const {getvendorId,VerifVendorOtp}=useVendorStore();
    const navigate=useNavigate();
  console.log("getvendorId:",getvendorId,"id",id)
  const [otp, setOtp] = useState(Array(4).fill("")); // 4-digit OTP
  const inputRefs = useRef([]);

  // handle input change
  const handleChange = (value,index) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // move focus to next box
      if (value && index < otp.length - 1) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  // handle backspace to go previous input
  const handleKeyDown = (e,index) => {
    if (e.key === "Backspace" &&  !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    const finalOtp = otp.join("");
    try {

        const res=await VerifVendorOtp(finalOtp,getvendorId);

        console.log("Otp res : ",res);

        alert("vendor logged in successfully")
        
        navigate('/auth/verify/broker-dashbord')
        
    } catch (error) {
        
        console.log("Error occures in Otp from ",error);
        
    }
  };

  return (
    <div className="flex items-center justify-center my-[5rem]">
      <form
        onSubmit={handleSubmit}
        className="w-[300px] h-[370px] bg-white flex flex-col items-center justify-center px-[40px] py-[30px] gap-[30px] relative shadow-[0_0_20px_rgba(0,0,0,0.082)] rounded-[15px]"
      >
        <span className="text-[1.1em] font-bold text-gray-900">Enter OTP</span>
        <p className="text-[0.7em] text-black leading-[17px] text-center">
          We have sent a verification code to your mobile number via WhatsApp
        </p>
        <div className="w-full flex flex-row gap-[10px] items-center justify-center">
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              inputMode="numeric" 
              maxLength={1}
              value={digit}
              onChange={(e) => handleChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className="bg-[rgb(228,228,228)] w-[40px] h-[40px] text-center rounded-[7px] caret-[rgb(127,129,255)] text-gray-800 outline-none font-semibold focus:bg-[rgba(127,129,255,0.199)] transition duration-300"
            />
          ))}
        </div>
        <button
          type="submit"
          className="w-full h-[35px] bg-[rgb(127,129,255)] text-white font-semibold cursor-pointer rounded-[10px] transition duration-200 hover:bg-[rgb(144,145,255)]"
        >
          Verify
        </button>
        <button
          type="button"
          className="absolute top-[5px] right-[5px] shadow-[0_0_20px_rgba(0,0,0,0.171)] bg-white rounded-full w-[25px] h-[25px] text-black text-[1.1em] cursor-pointer"
        >
          ×
        </button>
        <p className="text-[0.9em] text-black w-full flex flex-col items-center gap-[5px]">
          Didn't receive the code?{" "}
          <button
            type="button"
            className="bg-transparent text-[rgb(127,129,255)] cursor-pointer text-[1.3em] font-bold"
          >
            Resend Code
          </button>
        </p>
      </form>
    </div>
  );
};

export default OtpVerifyForm;
